import { BrowserRouter } from "react-router-dom";
import Router from "../../Router";

function App() {
  return (
    <BrowserRouter>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          margin: "-8px",
          boxSizing: "border-box",
          height: "100vh",
          width: "100vw",
          background: "linear-gradient(135deg, #000B16, #014F6D)",
        }}
      >
        <Router />
      </div>
    </BrowserRouter>
  );
}

export default App;
